import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";

const ROYAL = "#3B63E0";
const DEEP = "#1E40AF";

export default function FreeItemsSection() {
  const [items, setItems] = useState(null);
  const rowRef = useRef(null);
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    const el = rowRef.current;
    if (!el) return;
    const check = () => setCanScroll(el.scrollWidth > el.clientWidth + 1);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [items]);

  useEffect(() => {
    api.get("/free-listings", { params: { limit: 12 } })
      .then(({ data }) => setItems([...new Map((data || []).map((l) => [l.id, l])).values()]))
      .catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;
  const scroll = (dir) => rowRef.current?.scrollBy({ left: dir * 360, behavior: "smooth" });

  return (
    <section className="bg-white" style={{ borderTop: `3px solid ${ROYAL}` }} data-testid="free-items-section">
      <div className="mx-auto max-w-7xl px-4 py-5 sm:px-6">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-slate-900">
            <i className="ti ti-gift" style={{ fontSize: "18px", color: DEEP }} data-testid="free-items-icon" />
            Free Items — just pay delivery
          </h2>
          <Link to="/free" data-testid="free-items-see-all" className="text-sm font-semibold hover:underline" style={{ color: ROYAL }}>See all</Link>
        </div>
        <div className="relative">
          <button type="button" aria-label="Scroll left" data-testid="free-items-prev" onClick={() => scroll(-1)}
            className={`absolute -left-5 top-1/2 z-10 hidden h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white shadow-md transition-colors hover:bg-slate-50 ${canScroll ? "md:flex" : ""}`}>
            <ChevronLeft className="h-5 w-5 text-slate-700" />
          </button>
          <div ref={rowRef} className="ss-no-scrollbar flex gap-3 overflow-x-auto pb-1" data-testid="free-items-row">
            {items.map((l, i) => (
              <div key={l.id} className="w-[165px] shrink-0">
                <ListingCard listing={l} index={i} compact />
              </div>
            ))}
          </div>
          <button type="button" aria-label="Scroll right" data-testid="free-items-next" onClick={() => scroll(1)}
            className={`absolute -right-5 top-1/2 z-10 hidden h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white shadow-md transition-colors hover:bg-slate-50 ${canScroll ? "md:flex" : ""}`}>
            <ChevronRight className="h-5 w-5 text-slate-700" />
          </button>
        </div>
      </div>
    </section>
  );
}
